import axios from 'axios';

export const MAINTENANCE_STATUS_URL = `${process.env.REACT_APP_APII}maintenance/status`;
export const MAINTENANCE_POLL_INTERVAL_MS = 30000;

export async function checkMaintenanceStatus() {
  try {
    const response = await axios.get(MAINTENANCE_STATUS_URL, {
      withCredentialsForce: false,
      timeout: 10000,
    });

    return Boolean(response.data && response.data.maintenance === true);
  } catch (error) {
    return false;
  }
}
